import * as React from 'react';
import { MenuEntry } from '@europrocurement/flexy-components';
import { REALM_INTERN } from '@europrocurement/l2d-keycloak';
import FormalitiesListing from './views/listing/FormalitiesListing';
import FormalityAdd from './views/add/FormalityAdd';
import FormalityRoot from './views/FormalityRoot';
import FormalityShow from './views/show/FormalityShow';
import CompatibilitiesShow from './views/compatibilities/CompatibilitiesShow';
import {
    FORMALITIES_BASE_BATH,
    FORMALITY_COMPATIBILITIES,
    FORMALITY_LIST,
} from './constants/paths';

export const FormalityRouter = {
    path: FORMALITIES_BASE_BATH,
    element: <FormalityRoot />,
    children: [
        {
            path: 'liste',
            children: [
                {
                    path: '',
                    index: true,
                    element: <FormalitiesListing />,
                },
                {
                    path: ':formalityId',
                    element: <FormalityShow />,
                },
            ],
        },
        {
            path: 'compatibilites',
            element: <CompatibilitiesShow />,
        },
        {
            path: 'ajouter',
            element: <FormalityAdd />,
        },
    ],
};

const VALID_ROLES = [REALM_INTERN];

export const FormalityMenuEntries: MenuEntry[] = [
    {
        title: 'Gestion des Formalités',
        icon: 'gavel',
        role: VALID_ROLES,
        children: [
            {
                title: 'Liste des formalités',
                icon: 'gavel',
                href: FORMALITY_LIST,
                role: VALID_ROLES,
            },
            {
                title: 'Liste des compatibilités',
                icon: 'gavel',
                href: FORMALITY_COMPATIBILITIES,
                role: VALID_ROLES,
            },
        ],
    },
];
